var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContractMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39,41c0,1.6542969-1.3457031,3-3,3H12c-1.6542969,0-3-1.3457031-3-3V7c0-1.6542969,1.3457031-3,3-3h24 c1.6542969,0,3,1.3457031,3,3v15h2V7c0-2.7568359-2.2431641-5-5-5H12C9.2431641,2,7,4.2431641,7,7v34c0,2.7568359,2.2431641,5,5,5 h24c2.7568359,0,5-2.2431641,5-5v-1h-2V41z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 8,
    width: 16,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 14,
    width: 16,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 20,
    width: 16,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 15,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 21,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9697266,30.2578125c-0.0917969-0.3681641-0.3828125-0.6513672-0.7529297-0.734375l-4.0585938-0.9013672 l-2.2822266-4.1464844c-0.3515625-0.6386719-1.4003906-0.6386719-1.7519531,0l-2.2822266,4.1464844l-4.0585938,0.9013672 c-0.3701172,0.0830078-0.6611328,0.3662109-0.7529297,0.734375c-0.0917969,0.3671875,0.03125,0.7548828,0.3193359,1.0009766 l3.0546875,2.6191406l-0.8847656,4.4257812c-0.0761719,0.3828125,0.0761719,0.7744141,0.390625,1.0039062 c0.3154297,0.2314453,0.7353516,0.2548828,1.0751953,0.0664062L40,37.1435547l4.0146484,2.2304688 C44.1660156,39.4580078,44.3330078,39.5,44.5,39.5c0.2080078,0,0.4150391-0.0644531,0.5898438-0.1923828 c0.3144531-0.2294922,0.4667969-0.6210938,0.390625-1.0039062l-0.8847656-4.4257812l3.0546875-2.6191406 C47.9384766,31.0126953,48.0615234,30.625,47.9697266,30.2578125z M42.8496094,32.7412109 c-0.2753906,0.2353516-0.4013672,0.6005859-0.3300781,0.9550781l0.5761719,2.8789062l-2.6103516-1.4492188 C40.3349609,35.0419922,40.1669922,35,40,35s-0.3349609,0.0419922-0.4853516,0.1259766l-2.6103516,1.4492188l0.5761719-2.8789062 c0.0712891-0.3544922-0.0546875-0.7197266-0.3300781-0.9550781l-1.9814453-1.6992188l2.5478516-0.5654297 c0.2802734-0.0625,0.5205078-0.2421875,0.6591797-0.4941406L40,27.0322266l1.6240234,2.9501953 c0.1386719,0.2519531,0.3789062,0.4316406,0.6591797,0.4941406l2.5478516,0.5654297L42.8496094,32.7412109z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractMedium);
export default __webpack_public_path__ + "static/media/contract--medium.c592e115673ee1f8ddcaed9112b3ed4a.svg";
export { ForwardRef as ReactComponent };